import * as React from "react";
import { InputText } from "primereact/inputtext";

import { useAppSelector } from "../../redux/store.ts";
import { addOptionDialogFactory, isAddNewDriverTarget } from "./common.tsx";
import {
  api,
  DriverCreate,
  CreateDriverApiDriversPostApiArg,
  CreateDriverApiDriversPostApiResponse,
} from "../../api";

type DriverEditFormProps = {
  formContent: DriverCreate;
  setFormContent: React.Dispatch<React.SetStateAction<DriverCreate>>;
};

const DriverEditForm = ({
  formContent,
  setFormContent,
}: DriverEditFormProps) => (
  <>
    <div className="field">
      <label>
        Imię
        <span style={{ color: "red" }}> *</span>
      </label>
      <InputText
        value={formContent.first_name}
        onChange={(e) =>
          setFormContent((prev) => ({
            ...prev,
            first_name: e.target.value,
          }))
        }
        className="w-full"
        placeholder="Wpisz imię"
      />
    </div>
    <div className="field">
      <label>
        Nazwisko <span style={{ color: "red" }}> *</span>
      </label>
      <InputText
        value={formContent.last_name}
        onChange={(e) =>
          setFormContent((prev) => ({
            ...prev,
            last_name: e.target.value,
          }))
        }
        className="w-full"
        placeholder="Wpisz nazwisko"
      />
    </div>
    <div className="field">
      <label>ID</label>
      <InputText
        value={formContent.personal_code}
        keyfilter={"int"}
        maxLength={11}
        onChange={(e) =>
          setFormContent((prev) => ({
            ...prev,
            personal_code: e.target.value,
          }))
        }
        placeholder="Napisz kod identyfikacyjny"
        className="w-full"
      />
    </div>
    <div className="field">
      <label>Telefon</label>
      <InputText
        value={formContent.phone}
        max={128}
        onChange={(e) =>
          setFormContent((prev) => ({
            ...prev,
            phone: e.target.value,
          }))
        }
        placeholder="Napisz numer telefonu"
        className="w-full"
      />
    </div>
    <div className="field">
      <label>E-mail</label>
      <InputText
        value={formContent.email}
        onChange={(e) =>
          setFormContent((prev) => ({
            ...prev,
            email: e.target.value,
          }))
        }
        placeholder="Napisz e-mail"
        className="w-full"
      />
    </div>
  </>
);

const emptyDriver = {
  first_name: "",
  last_name: "",
  personal_code: undefined,
  phone: undefined,
  email: undefined,
} as const satisfies DriverCreate;

const DriverAddOptionDialog = addOptionDialogFactory<
  DriverCreate,
  CreateDriverApiDriversPostApiArg,
  CreateDriverApiDriversPostApiResponse
>({
  defaultValues: emptyDriver,
  FormComponent: DriverEditForm,
  useMutation: api.endpoints.createDriverApiDriversPost.useMutation,
  createMutationArg: (formContent) => ({ driverCreate: formContent }),
  validate: (formContent) =>
    !!(formContent.first_name && formContent.last_name),
  headerText: "Edytuj kierowcę",
});

export const DriverAddOption: React.FC = () => {
  const { target } = useAppSelector((state) => state.addNew);
  if (!isAddNewDriverTarget(target)) {
    return null;
  }
  return (
    <DriverAddOptionDialog
      rowId={target.id}
      field={target.field}
      initialValues={target.initialValues}
    />
  );
};
